import { useEffect } from "react";
import Banner from "../components/Banner";
import CategoryComponent from "../components/Category";
import DeliverySection from "../components/Delivery";
import { useTranslation } from "react-i18next";

const HomePage = () => {
  const { i18n } = useTranslation();

  // Direction control
  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-[#f2e6db] py-4 sm:py-6 lg:py-8">
      <Banner />
      <CategoryComponent />

      <DeliverySection />
    </div>
  );
};

export default HomePage;
